import type { TranslateFn } from 'src/i18n/shim/useTranslation';

/** Rows per page for the client-side pagination of both Track tables. */
export const TRACK_PAGE_SIZE = 50;

/** Server `pageSize` for one Track fetch. */
export const TRACK_FETCH_BATCH_SIZE = 100;

/** Batches fetched without user action: the first one, then the auto-chain. */
export const TRACK_INITIAL_BATCHES = 5;

/** Pagination labels shared by both Track tables. */
export const trackPaginationAriaLabels = (t: TranslateFn) => ({
  nextPageLabel: t('track-pagination-next'),
  previousPageLabel: t('track-pagination-previous'),
  pageLabel: (pageNumber: number) => t('track-pagination-page', { pageNumber }),
});

/**
 * Panther resource ids for the Track Translations feature. Named `*_IDS` so a call site still
 * rendering a raw literal fails to compile.
 */
export const TRACK_STRING_IDS = {
  PAGE_TITLE: 'track-page-title',
  PAGE_DESCRIPTION: 'track-page-description',

  ERROR_ACTIVE_HEADER: 'track-error-active-header',
  ERROR_HISTORICAL_HEADER: 'track-error-historical-header',
  ERROR_BODY: 'track-error-body',

  ACTIVE_JOBS_HEADER: 'track-active-header',
  /** Info tooltip to the right of the heading and its result count. */
  ACTIVE_JOBS_INFO: 'track-active-info',
  ACTIVE_JOBS_LOADING: 'track-active-loading',
  ACTIVE_JOBS_EMPTY_TITLE: 'track-active-empty-title',
  ACTIVE_JOBS_EMPTY_BODY: 'track-active-empty-body',

  HISTORICAL_JOBS_HEADER: 'track-historical-header',
  /** Info tooltip to the right of the heading and its result count. */
  HISTORICAL_JOBS_INFO: 'track-historical-info',
  HISTORICAL_JOBS_LOADING: 'track-historical-loading',
  HISTORICAL_JOBS_EMPTY_TITLE: 'track-historical-empty-title',
  HISTORICAL_JOBS_EMPTY_BODY: 'track-historical-empty-body',

  LOAD_MORE: 'track-load-more',

  SORT_WINDOW_NOTICE_DISMISS: 'track-sort-notice-dismiss',

  /** Shown only while more jobs remain unloaded AND the user has sorted. Takes a loadedCount
   * ICU argument at the call site. */
  SORT_WINDOW_NOTICE: 'track-sort-notice',
} as const;
